import { render, staticRenderFns } from "./IndexJiazhang06.vue?vue&type=template&id=1215adf0&"
import script from "./IndexJiazhang06.vue?vue&type=script&lang=js&"
export * from "./IndexJiazhang06.vue?vue&type=script&lang=js&"
import style0 from "./IndexJiazhang06.vue?vue&type=style&index=0&id=1215adf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports